import React, { useContext, useEffect, useState } from 'react';
import './ReportProblem.css';
import { AppInfoContext } from '../../../../../App';
import MainModal from '../components/MainModal';
import ReportTypeSelection from './ReportTypeSelection';
import AcceptedUnprocessedIssues from './components/AcceptedUnprocessedIssues';
import ProblemLocation from './components/ProblemLocation';
import ProblemCoordinates from './components/ProblemCoordinates';
import ProblemLocationSelected from './components/ProblemLocationSelected';
import ReportProblemForm from './components/ReportProblemForm';
import SubmitFormMessage from './components/SubmitFormMessage';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

function ReportProblem() {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);
  const [currentFormStep, setCurrentFormStep] = useState(0);
  const [isMinimized, setIsMinimized] = useState(false);
  const isMobile = useIsMobile();

  const returnToMainMenu = () => {
    setAppInformation((prevValue) => {
      const { maintenance } = prevValue;
      return {
        ...prevValue,
        maintenance: {
          ...maintenance,
          currentOption: 0,
        },
      };
    });
  };

  const [formInfo, setFormInfo] = useState({});

  const increaseFormStep = () => {
    setCurrentFormStep((prevValue) => prevValue + 1);
  };

  const decreaseFormStep = () => {
    setCurrentFormStep((prevValue) => prevValue - 1);
  };

  const mutualModalProps = {
    closeModal: returnToMainMenu,
    increaseFormStep: increaseFormStep,
    decreaseFormStep: decreaseFormStep,
    formInfo,
    setFormInfo,
    isMinimized,
    setIsMinimized,
    currentReportProblemFormStep: currentFormStep,
  };

  const modalOptions = {
    0: { title: 'Tip unosa kvara', component: ReportTypeSelection },
    1: {
      title: 'Odaberite prijavu građana',
      component: AcceptedUnprocessedIssues,
    },
    2: {
      title: 'Unos kvara',
      component: ProblemLocation,
    },
    3: {
      title: 'Unos kvara',
      component: ProblemLocationSelected,
    },
    4: {
      title: 'Unos kvara',
      component: ReportProblemForm,
    },
    5: {
      title: formInfo?.formSubmitStatus
        ? 'Prijava uspješna'
        : 'Prijava neuspješna',
      component: SubmitFormMessage,
    },
  };

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (currentFormStep === 3) {
      const timer = setTimeout(() => {
        setVisible(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [currentFormStep]);

  return formInfo?.problemLocation?.coordinates?.x ? (
    <>
      {visible && (
        <div
          className={
            currentFormStep === 4
              ? 'report-problem report-problem-desktop'
              : 'report-problem'
          }
          style={{
            height:
              ((isMobile && isMinimized) ||
                (!isMobile && currentFormStep === 4)) &&
              'auto',
          }}
        >
          <div className="report-body">
            {modalOptions[currentFormStep] && (
              <MainModal
                title={modalOptions[currentFormStep].title}
                component={modalOptions[currentFormStep].component}
                {...mutualModalProps}
              />
            )}
          </div>
        </div>
      )}
    </>
  ) : !formInfo?.problemLocation?.locationSelection ? (
    <div
      className={
        currentFormStep === 4
          ? 'report-problem report-problem-desktop'
          : 'report-problem'
      }
      style={{
        height:
          ((isMobile && isMinimized) || (!isMobile && currentFormStep === 4)) &&
          'auto',
      }}
    >
      <div className="report-body">
        {modalOptions[currentFormStep] && (
          <MainModal
            title={modalOptions[currentFormStep].title}
            component={modalOptions[currentFormStep].component}
            {...mutualModalProps}
          />
        )}
      </div>
    </div>
  ) : (
    <ProblemCoordinates
      {...mutualModalProps}
      setProblemLocationCoordinates={(newX, newY) => {
        setFormInfo((prevValue) => {
          const { problemLocation } = prevValue;
          return {
            ...prevValue,
            problemLocation: {
              ...problemLocation,
              locationSelection: !problemLocation.locationSelection,
              coordinates: { x: newX, y: newY },
            },
          };
        });

        increaseFormStep();
      }}
    />
  );
}

export default ReportProblem;
